var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('modal',{ref:"modal"}),_c('div',{ref:"webgl-main-container",staticClass:"webgl-main-container"}),_c('transition-panel',{ref:"transition"}),_c('router-view',{ref:"router-view",staticClass:"router-view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }